import angular from 'angular';

angular
  .module('cxSettings')
  .controller('RecognitionOptionsDialogCtrl', [
    '$element',
    '$http',
    'appUrls',
    'flySvc',
    'close',
    'dataCache',
    'magicMailAllowedAttachmentSenders',
    'linkEmailToCrmOther',
    'linkEmailToCrmProspect',
    'linkEmailToCrmOwnCompany',
    recognitionOptionsDialogCtrl,
  ]);

function recognitionOptionsDialogCtrl(
  $element,
  $http,
  appUrls,
  flySvc,
  close,
  dataCache,
  magicMailAllowedAttachmentSenders,
  linkEmailToCrmOther,
  linkEmailToCrmProspect,
  linkEmailToCrmOwnCompany,
) {
  var vm = this;
  vm.magicMailAllowedAttachmentSendersArray = [];
  vm.linkEmailToCrmOther = linkEmailToCrmOther;
  vm.linkEmailToCrmProspect = linkEmailToCrmProspect;
  vm.linkEmailToCrmOwnCompany = linkEmailToCrmOwnCompany;

  if (magicMailAllowedAttachmentSenders) {
    vm.magicMailAllowedAttachmentSendersArray = magicMailAllowedAttachmentSenders.split(';');
  }

  vm.addEmail = () => {
    vm.magicMailAllowedAttachmentSendersArray.push('');
  };

  vm.save = function() {
    close(
      {
        linkEmailToCrmOther: vm.linkEmailToCrmOther,
        linkEmailToCrmProspect: vm.linkEmailToCrmProspect,
        linkEmailToCrmOwnCompany: vm.linkEmailToCrmOwnCompany,
        magicMailAllowedAttachmentSenders:
          vm.magicMailAllowedAttachmentSendersArray.length === 0
            ? ''
            : vm.magicMailAllowedAttachmentSendersArray.join(';'),
      },
      500,
    );
    $element.modal('hide');
  };

  vm.cancel = function() {
    close(null, 500);
    $element.modal('hide');
  };
}
